import { FC } from 'react';
import styled from 'styled-components';

import { ReactComponent as CommentIcon } from '@/assets/icons/comment.svg';
import Text from '@/components/Text';

const Box = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: flex-start;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.grayscaleLight};
  gap: 8px;
  svg {
    color: ${({ theme }) => theme.colors.gray};
    flex-shrink: 0;
  }
`;

interface Props {
  comment: string;
}

const ImageComment: FC<Props> = ({ comment }) => {
  return (
    <Box>
      <CommentIcon />
      <Text $type="smallText">{comment}</Text>
    </Box>
  );
};

export default ImageComment;
